import ROUTES, { compareRoute } from '@app/routes';

const submenu = (companyId, solutions, selectedDropDown, currentRoute, { qrcodeOption, followUpOption }, callback, addCallback, t) => [
  ...solutions
    .filter((t) => t.type === 'VSG')
    .map((s, i) => ({
      name: s.name ? s.name : t('VSG #{{index}}', { index: i + 1 }),
      selected: false,
      open: selectedDropDown === `VSG-${s.id}`,
      onClick: () => {
        callback(`VSG-${s.id}`);
      },
      children: [
        {
          name: t('Data'),
          icon: 'ANALYTICS',
          selected: compareRoute(`company/${companyId}/vsg/${s.id}/data`, currentRoute),
          onClick: `/company/${companyId}/vsg/${s.id}/data`,
        },
        {
          name: t('Preview'),
          icon: 'EYE',
          selected: compareRoute(ROUTES.VSG_PREVIEW.path({ companyId, solutionId: s.id }), currentRoute),
          onClick: ROUTES.VSG_PREVIEW.path({ companyId, solutionId: s.id }),
        },
        {
          name: t('Configuration'),
          icon: 'SETTING',
          selected: compareRoute(ROUTES.SOLUTION_CONFIGURATION.path({ solutionId: s.id, solutionType: 'vsg', companyId }), currentRoute),
          onClick: ROUTES.SOLUTION_CONFIGURATION.path({ solutionId: s.id, solutionType: 'vsg', companyId }),
        },
      ],
    })),
  {
    name: t('New VSG'),
    icon: 'ADD',
    selected: false,
    onClick: addCallback,
  },
];

export default submenu;
